import './TabSelector.scss';

export const TabSelector = ({ tabs, selectedTab, onTabSelect }) => {
  return (
    <div className="tab-selector">
      {tabs.map(({ key, title, image }) => (
        <div key={key} className={`tab ${selectedTab === key ? 'selected' : ''}`} onClick={() => onTabSelect(key)}>
          <img src={image} alt={title} />
          <div className="tab-title">{title}</div>
        </div>
      ))}
    </div>
  );
};
